import { render, staticRenderFns } from "./UserRoster.vue?vue&type=template&id=0567f3bd"
import script from "./UserRoster.vue?vue&type=script&lang=js"
export * from "./UserRoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports